import React from "react";
import { useTranslation } from "react-i18next";
function Banner() {
  const {t} = useTranslation()
  return (
    <div className="login_banner">
      
      <div className="container">
        <div className="logo_im">LOGO</div>
        <div className="login_content">
          <h3>{t('Pay Now')}</h3>
          <p>
            {t('Either late when Stenorat listens in. Especially this time.')} <br />
            {t('Chaotic/damaged label, super-magnificent and gigantic.')}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Banner;
